import BaseEntity from './base/BaseEntity.model';

export default class Document extends BaseEntity{
    public contentTypeId?: number;
    public refEntityName?: string;
    public refEntityKey?: string;
    public refEntityValue?: string;
    public reflanguage?: string
    constructor(public fileName?: string, public contentType?: string, public originalName?: string, public language?: string){
        super();
    }
}